import type { GatsbySSR } from 'gatsby'

import { AppProvider } from '@/components/site-components/app-provider'

export const wrapWithProvider: GatsbySSR['wrapRootElement'] = ({ element }) => {
  return <AppProvider>{element}</AppProvider>
}
